import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist',
  templateUrl: './whitelist.component.html',
  styleUrls: ['./whitelist.component.scss']
})
export class WhitelistComponent implements OnInit {
  search_string: any = ''
  whitlistOutlet: any
  getPaginationCount: any
  page: any = 1
  pageLength:any
  excelData: any
  uploadHidden: boolean = false
  WhitlistResponse: any = []
  status: any
  @Input() cashBackId
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private exportExcel: ExportExcelService,
    private xlsx: XlsxService,
    private toast: ToastClientService

  ) { }
  ngOnChanges() {
    console.log(this.cashBackId)
    if (this.cashBackId != undefined && this.cashBackId != 0) {
      this.getWhiteListOutlets()
    }
  }
  ngOnInit() {
    console.log(this.cashBackId)
  }

  downloadExcel() {
    let header = ["outlet_code", "mobile_number"]
    this.exportExcel.commonPrintHeaders(header, "Whitelistoutlets")

  }

  uploadXlsx(event) {
    console.log(event.target.files[0])
    // event.target.files[0]
    this.xlsx.uploadXlsx(event).then((res: any) => {
      console.log(res)
      this.whiteListOutlets(res)
    })
  }

  changeStatus(item,id) {
    item == true && console.log(item)
    let payload = {
      "campaign_id":this.cashBackId,
        "id":id,
        "status": item == true ? 1 : 0
    }
    this.apiService.post(this.apiConfig.WhitelistOutletDisable,payload).subscribe((res:any)=>{
      console.log(res)
      this.getWhiteListOutlets()
      this.toast.Success((res.body.data.message))
    })
  }

  filterRecord() {
    this.getWhiteListOutlets()
  }

  resetRecod() {
    this.search_string = ''
    this.getWhiteListOutlets()
  }
  whiteListOutlets(res) {

    let payload = {
      cashback_id: this.cashBackId,
      excel_data: res.data
    }
    console.log(payload)
    this.apiService.post(this.apiConfig.WhitelistOutlet, payload).subscribe((res) => {
      console.log(res)
      this.WhitlistResponse = res.body.data
      res.body.success == true ? this.toast.Success("Uploaded Succesfully") : this.toast.Success("Failed")
      this.uploadHidden = true
      this.modalService.dismissAll()
      this.getWhiteListOutlets()
    })
  }

  DownloadRejectedRecords() {
    this.xlsx.export(this.WhitlistResponse.fail, "rejected_list")
  }

  getWhiteListOutlets() {
    console.log(this.cashBackId)
    this.apiService.getHeaders(this.apiConfig.cashbackWhitelisters + `?cashback_config_id=${this.cashBackId}&code=${this.search_string}`).subscribe((res: any) => {
      console.log(res.body.data)
      this.whitlistOutlet = res.body.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
      this.pageLength = res.headers.get("X-Pagination-Per-Page")

    })
  }

  paginationClick(pageNumber) {
    this.page = pageNumber
    this.getWhiteListOutlets()
  }

  OpenExcelModal(templateModal) {
    this.modalService.open(templateModal, { centered: true, size: 'md' })
  }

}
